import { render, staticRenderFns } from "./DetailInvestigator.vue?vue&type=template&id=1fd35cba&lang=html"
import script from "./DetailInvestigator.vue?vue&type=script&lang=js"
export * from "./DetailInvestigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports